import moment from "moment";
import { useTranslation } from "react-i18next";
import { Appointment } from "../../../state/appointments";
import AppointmentsTable, {
  AppointmentColumn,
  TextCell,
  PatientNameCell,
  StatusCell
} from "./AppointmentsTable";

interface Props {
  /** Past appointments to list (already filtered/sorted by the caller). */
  rows: Appointment[];
  /** patientName (lowercased) → picture URL. */
  pictureMap: Record<string, string>;
  /** patientName (lowercased) → patient number. */
  nhsIdMap: Record<string, string>;
}

export default function AppointmentHistoryTable({
  rows,
  pictureMap,
  nhsIdMap
}: Props) {
  const { t } = useTranslation();

  const columns: AppointmentColumn[] = [
    {
      key: "patient",
      label: t("videoConsultations.tablePatient"),
      render: appt => (
        <PatientNameCell
          appt={appt}
          pictureUrl={pictureMap[appt.patientName.toLowerCase()]}
        />
      )
    },
    {
      key: "nhsId",
      label: t("videoConsultations.tableNhsId"),
      width: "140px",
      render: appt => (
        <TextCell>{nhsIdMap[appt.patientName.toLowerCase()] ?? "—"}</TextCell>
      )
    },
    {
      key: "day",
      label: t("videoConsultations.tableDay"),
      width: "140px",
      render: appt => (
        <TextCell>{moment(appt.start).format("DD/MM/YYYY")}</TextCell>
      )
    },
    {
      key: "time",
      label: t("videoConsultations.tableStartTime"),
      width: "130px",
      render: appt => <TextCell>{moment(appt.start).format("HH:mm")}</TextCell>
    },
    {
      key: "duration",
      label: t("videoConsultations.tableDuration"),
      width: "120px",
      render: appt => <TextCell>{appt.durationMinutes} min</TextCell>
    },
    {
      key: "status",
      label: t("videoConsultations.tableStatus"),
      width: "120px",
      render: appt => <StatusCell appt={appt} />
    }
  ];

  return <AppointmentsTable columns={columns} rows={rows} />;
}
